export default __webpack_public_path__ + "static/media/AAPG-Pivoting-7.794c8621.jpg";